import React from 'react';

import cl from './Cards.module.css'

import paymentItem1Img from '../../../assets/images/paymentServices.png'
import paymentItem2Img from '../../../assets/images/paymentServices2.png'
import paymentItem3Img from '../../../assets/images/paymentServices3.png'

import blackImgPenNote from '../../../assets/images/blackpenImg.png'
import whiteCircleImg from '../../../assets/images/whiteCircle.png'
import { NavLink } from 'react-router-dom';
import {Helmet} from "react-helmet-async";



const Cards = () => {
    return (
        <div className={cl.cards_wrapper}>
            <Helmet>
                <title>Fortres BanCorp Cards | Secure Global Payment Cards</title>
                <meta name="description" content="Access secure payment cards for everyday spending, international transactions, and online purchases with Fortres digital banking." />
                <meta name="keywords" content="digital payment cards, virtual debit cards, global payment cards, fintech cards" />
            </Helmet>
            <div className={cl.payments_container}>
                <h1 className={cl.payments_title}>
                    Global Payments & Card Services
                </h1>
                <div className={cl.payments_items_row}>
                    <div className={cl.payment_item}>
                        <div className={cl.img_payment_wrapper}>
                            <img src={paymentItem1Img} alt="#" />
                        </div>
                        <div className={cl.payment_descr_wrapper}>
                            <p className={cl.payment_descr}>
                                Global card services that simplify money management for travel and business.
                            </p>
                        </div>
                    </div>
                    <div className={cl.payment_item}>
                        <div className={cl.img_payment_wrapper}>
                            <img src={paymentItem2Img} alt="#" />
                        </div>
                        <div className={cl.payment_descr_wrapper}>
                            <p className={cl.payment_descr}>
                                We handle cash flows, licensing, and compliance with global partners—so every transaction runs on a fully regulated offshore bank.
                            </p>
                        </div>
                    </div>
                    <div className={cl.payment_item}>
                        <div className={cl.img_payment_wrapper}>
                            <img src={paymentItem3Img} alt="" />
                        </div>
                        <div className={cl.payment_descr_wrapper}>
                            <p className={cl.payment_descr}>
                                Protect, access, and grow your wealth worldwide—plus seamless global debit card access.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className={cl.joing_us_background}>
                <div className={cl.join_us_container}>
                    <div className={cl.left_content}>
                        <h2 className={cl.left_content_pre_title}>
                            JOIN US
                        </h2>
                        <h2 className={cl.left_title}>
                            Sign Up Today
                        </h2>
                        <div className={cl.left_description_wrapper}>
                            <p className={cl.left_description}>
                                Enjoy effortless international payments with Fortres BanCorp.
                            </p>
                        </div>
                        <NavLink to='/sign-up'>
                            <div className={cl.sign_up_btn}>
                                Sign Up
                            </div>
                        </NavLink>
                    </div>
                    <div className={cl.right_content}>
                        <div className={cl.image_wrapper}>
                            <img src={blackImgPenNote} className={cl.blackImgPenNote} alt="" />
                            <img src={whiteCircleImg} className={cl.white_circle} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cards;